// extracted by mini-css-extract-plugin
export default {"shopHeader":"ShopDisplay_shopHeader__xue0C","shopItems":"ShopDisplay_shopItems__XjOjb","itemContainer":"ShopDisplay_itemContainer__75gzQ"};